import React, { Component } from "react";
import "component/game/GameItemBanner/styles.scss";
import defaultBanner from "assets/images/bannerDefault.png";
import { ReactComponent as Play } from "assets/icons/Play-Launch.svg";
import { ReactComponent as PlayDemo } from "assets/icons/play-demo.svg";
import { setDefaultImageFormat } from "utils/image";
import { getTotalPool } from "utils/getTotalpool";
import { is } from "immutable";
import { withNamespaces } from "react-i18next";

class GameItemBanner extends Component {
  constructor(props) {
    super(props);
    this.loadGame = this._loadGame.bind(this);
    this.getTotalPool = getTotalPool.bind(this);
    this.state = {
      game: null,
      bannerUrl: null,
      isLoading: true,
      linkReal: null,
      linkDemo: null,
      jackpotPool: null,
    };
  }

  _loadGame(game) {
    this.setState({
      game: null,
      bannerUrl: null,
      isLoading: true,
      linkReal: null,
      linkDemo: null,
      jackpotPool: null,
    });

    let newGame = game;

    if (newGame.get("playType") === "game.details") {
      newGame = newGame.set("playType", "launch.real");
    }

    this.props
      .fetchGame(newGame)
      .then((resp) => {
        this.setState({
          game: resp.payload,
        });
        return resp;
      })
      .then((resp) => {
        let linkDemo = resp.payload.get("links").find((link) => {
          return link.get("rel") === "launch.demo";
        });

        let linkReal = resp.payload.get("links").find((link) => {
          return link.get("rel") === "launch.real";
        });

        this.setState({
          bannerUrl: resp.payload.getIn(["images", "bannerUrl"]),
          linkDemo,
          linkReal,
        });
      });
  }

  componentDidMount() {
    if (this.props.game) {
      this.loadGame(this.props.game);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.state.game &&
      nextProps.latestBroadcast &&
      nextProps.latestBroadcast.get("jackpotGroupId") ===
        this.state.game.get("jackpotGroupId")
    ) {
      let latestJackpotPool;
      latestJackpotPool = {
        type: nextProps.latestBroadcast.get("type"),
        amount: nextProps.latestBroadcast.get("amount"),
      };
      this.setState({
        jackpotPool: {
          ...this.state.jackpotPool,
          [latestJackpotPool.type]: { amount: latestJackpotPool.amount },
        },
      });
    } else {
      this.setState({ jackpotPool: null });
    }

    if (!is(nextProps.game, this.props.game) && nextProps.game) {
      this.loadGame(nextProps.game);
    }
  }

  render() {
    const { t } = this.props;

    return (
      <div className="game-item-banner d-flex justify-content-center align-items-center">
        <div className="background-container">
          {!this.state.isLoading && (
            <>
              <div
                className="background"
                style={{
                  backgroundImage: `url(${setDefaultImageFormat(
                    this.state.bannerUrl + "width=800&theme=dark&",
                    this.props.imageFormat.get("banner")
                  )})`,
                }}
              />
              <div className="background-gradient-overlay"></div>
            </>
          )}
        </div>
        {this.state.isLoading && (
          <div
            className="background"
            style={{
              backgroundImage: `url(${defaultBanner})`,
            }}
          />
        )}

        <div className="banner-container d-flex justify-content-center align-items-center">
          {this.state.bannerUrl && (
            <img
              className={this.state.isLoading ? "d-none" : ""}
              src={`${setDefaultImageFormat(
                this.state.bannerUrl + "&width=1000&theme=dark&",
                this.props.imageFormat.get("banner")
              )}`}
              alt="banner"
              onLoad={() => {
                this.setState({
                  isLoading: false,
                });
              }}
            />
          )}
          {this.state.isLoading && <img src={defaultBanner} alt="banner" />}
          {this.state.game && (
            <div className="jackpot-amount">
              {this.getTotalPool(
                this.state.jackpotPool,
                this.state.game,
                false
              )}
            </div>
          )}
          
          {(this.state.linkReal || this.state.linkDemo) && (
            <div className="button-group-container">
              <div className="gradient-overlay"></div>
              <div className="button-group">
                {this.state.linkReal && (
                  <button
                    className="btn btn-danger w-100"
                    onClick={(event) => {
                      let gameId = this.state.game.get("gameId");
                      let playType = this.state.linkReal.get("rel");
                      let nav = this.state.game.get("nav");
                      this.props.onGameItemClickHandler({
                        gameId,
                        playType,
                        nav,
                      });
                      event.stopPropagation();
                    }}
                  >
                    <span className="play-now-icon">
                      <Play />
                    </span>
                    &nbsp;
                    {t("playNow")}
                  </button>
                )}
                {this.state.linkDemo && (
                  <button
                    className="btn btn-secondary w-100"
                    onClick={(event) => {
                      let gameId = this.state.game.get("gameId");
                      let playType = this.state.linkDemo.get("rel");
                      this.props.onGameItemClickHandler({
                        gameId,
                        playType,
                      });
                      event.stopPropagation();
                    }}
                  >
                    <span className="play-now-icon">
                      <PlayDemo />
                    </span>
                    &nbsp;{t("demoPlay")}
                  </button>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default withNamespaces("translation")(GameItemBanner);
